import { ChevronLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import MainUserDetail from "../components/user-detail-component/main-user-detail";

const BACK_CONFIG = {
  approve: {
    path: "/dashboard/users/approve-users",
    label: "Back to User Approval",
    title: "User Detail",
    subtitle: "Review user details and documents for approval",
  },
  nonprofit: {
    path: "/dashboard/users/nonprofit-users",
    label: "Back to Non-Profit Users",
    title: "Non-Profit User Detail",
    subtitle: "View non-profit organization profile and information",
  },
  pin: {
    path: "/dashboard/users/pin-users",
    label: "Back to People-In-Need Users",
    title: "People-In-Need User Detail",
    subtitle: "View people-in-need user profile and information",
  },
};

function UserDetail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const from = searchParams.get("from") || "approve";
  const config = BACK_CONFIG[from] ?? BACK_CONFIG.approve;

  return (
    <div className="w-[95%] mx-auto">
      <div className="my-6">
        <div className="mb-3">
          <h1 className="font-popinsSemiBold text-xl lg:text-2xl mb-1">
            {config.title}
          </h1>
          <p className="text-black/50 font-popinsRegular text-sm">
            {config.subtitle}
          </p>
          <button
            onClick={() => navigate(config.path)}
            className="relative overflow-hidden py-1 px-3 border border-gray-300 text-gray-500 font-popinsRegular text-xs rounded
                     transform transition duration-300 ease-in-out
                     hover:border-gray-400 hover:text-gray-600 hover:bg-gray-50
                     active:scale-95 focus:outline-none
                     flex items-center gap-x-1.5 mt-4"
          >
            <ChevronLeft size={12} />
            <span>{config.label}</span>
          </button>
        </div>
      </div>
      <MainUserDetail from={from} />
    </div>
  );
}

export default UserDetail;
